import store from '@/store/index'
import { logsCollection } from '../../firebase'
import moment from 'moment/src/moment'

class LogModule {
  logs = {
    get() {
      return store.state.logs
    },
    set(logs) {
      store.commit('SET_LOGS', logs)
    }
  }

  logsComplete = {
    get() {
      return store.state.logsComplete
    }
  }

  calculateLogsComplete() {
    const logsComplete = store.state.logs.reduce((isComplete, log) => {
      return log.isComplete ? (isComplete += 1) : isComplete
    }, 0)
    store.commit('SET_LOGS_COMPLETE', logsComplete)
  }

  getLogsForMonthYear(habitId, year, month) {
    if (!habitId) return

    store.state.logs = []
    let logsComplete = 0
    logsCollection
      .where('userId', '==', store.state.user.id)
      .where('habitId', '==', habitId)
      .where('year', '==', year)
      .where('month', '==', month)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (doc.data().isComplete) logsComplete += 1
          store.state.logs.push({ ...doc.data(), id: doc.id })
        })
      })
      .then(() => {
        store.commit('SET_LOGS_COMPLETE', logsComplete)
      })
  }

  getLogsForWeek() {
    store.state.logs = []
    const year = moment().year()
    const todayIsSunday = moment().day() === 0
    const momentWeek = moment().week()

    store.state.habits.forEach(habit => {
      const week = todayIsSunday ? momentWeek - 1 : momentWeek

      // getLogs Mon - Sat
      _getLogs(habit.id, year, week, 0, '!=')

      // getLogs for upcoming Sunday
      if (!todayIsSunday) {
        _getLogs(habit.id, year, momentWeek + 1, 0, '==')
      }
      // getLogs for today (Sunday)
      if (todayIsSunday) {
        _getLogs(habit.id, year, momentWeek, 0, '==')
      }
    })
  }
}

function _getLogs(habitId, year, week, day, operator) {
  logsCollection
    .where('userId', '==', store.state.user.id)
    .where('habitId', '==', habitId)
    .where('year', '==', year)
    .where('week', '==', week)
    .where('weekday', operator, day)
    .get()
    .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        store.state.logs.push({ ...doc.data(), id: doc.id })
      })
    })
}

export default new LogModule()
